export default (editor, opts = {}) => {
    const $ = editor.$;
    const pfx = editor.getConfig().stylePrefix;
    const pn = editor.Panels;
    const template = $(`<div id="${pfx}pn-devices" class="${pfx}pn-float ${pfx}one-bg"></div>`);
    template.append(pn.getPanel('devices').view.$el);
    return template;
}